import { render, staticRenderFns } from "./Close.vue?vue&type=template&id=72663e2d&"
import script from "./Close.vue?vue&type=script&lang=ts&"
export * from "./Close.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports